import { render, staticRenderFns } from "./sup-withdraw-mtpay.vue?vue&type=template&id=bc7dc222"
import script from "./sup-withdraw-mtpay.vue?vue&type=script&lang=js"
export * from "./sup-withdraw-mtpay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports